export {
  createSim,
  createWorld,
  createLeagueFromWizard,
  editTeam,
  joinLeague,
  inviteCode,
  slugify,
  gameFor,
  projectionFor,
  pointsFor,
  FRIENDS_SEEDS,
  OFFICE_SEEDS,
  FAMILY_SEEDS,
} from './league';
export type { SimState, SimTeam, SimPlayer, LeagueOptions, TeamSeed } from './league';
export {
  GAME_SECONDS,
  gameLabel,
  gameProgress,
  kickoffLabel,
  // Exported for the seeder, which turns a simulated week into `stat.line`
  // facts so seeded players reach `player_period_stats` through the same
  // projection real ones do. Nothing in the app calls these directly.
  lineAt,
  playerEvents,
  type GameEvent,
  type ProGame,
} from './games';
// A whole season rather than one week (BACKLOG S1). Additive: `buildProSchedule`
// above still builds the single week the web simulator and the seeder run on.
export {
  DEFAULT_BYE_RANGE,
  DEFAULT_WEEKS,
  buildProSeason,
  buildSeasonLines,
  type ProSeason,
  type SeasonGame,
  type SeasonLine,
  type SeasonOptions,
  type SeasonPlayer,
  type SeasonWeek,
} from './season';
export { PLAYER_SEEDS, type PlayerSeed, type SimPosition } from './players';
export {
  homeView,
  hubView,
  leagueCard,
  leagueChores,
  leagueRef,
  lineupView,
  matchupView,
  matchupSummary,
  myMatchupId,
  scoreboardView,
  standingsView,
  playersPage,
  // Worth a look's page in the practice league (PLAN-2026-10-27-worth-a-look §7).
  worthALookView,
  periodRef,
  lineupHealth,
  teamRef,
  // A player's card from his id alone (the web's PlayerCardHost, B-220).
  playerSummary,
  gameStatus,
  projection,
  basisFor,
  livePoints,
} from './views';
export { rng, hashSeed } from './rng';
export { calendarSimView } from './calendar';
export { saveSettings, previewSettings } from './settings';
export { chatView, postChat, reactChat, advanceChat, pulseFromChat, readableColor } from './chat';
export { advanceLeague } from './tick';
export {
  advanceWaivers,
  placeClaim,
  withdrawClaim,
  reorderClaims,
  addPlayer,
  dropPlayer,
  undoTransaction,
  waiversView,
  waiversLogPage,
  rosterMoveView,
  processesAt,
  waiverOrder,
} from './waivers';
export type { ClaimInput, WaiverState, PlannedMove } from './waivers';
export {
  tradeIntent,
  advanceTrades,
  tradesView,
  tradeView,
  tradeBuilderView,
  onProposed,
  setTradeBlock,
} from './trades';
export type { TradeState, BuilderInput } from './trades';
export { scheduleView, bracketView, bracketShape, bracketOrder, roundName } from './playoffs';
export {
  awardsView,
  trophyRoomView,
  wrapView,
  yearbookView,
  seasonFacts,
  advanceAwards,
  periodFinalAt,
  pickHat,
} from './awards';
export type { AwardState } from './awards';
export { recapView, nextPeriodInput } from './recap';
export { newsItems, playerNews } from './news';
export { historyView } from './history-view';
export type { PeriodTeamDetail } from './history';
export {
  openDraft,
  startDraft,
  draftIntent,
  advanceDraft,
  completeDraft,
  draftView,
  draftRoomOpen,
  draftContext,
  draftRecapView,
} from './draft';
export type { SaveResult, SettingsPreview, PreviewRow } from './settings';

/** A sensible "now" for the default sim: Sunday 3:30 PM ET of the current period, early games in Q4, late games not yet kicked off. */
export function defaultNow(state: { sundayUtcMidnight: number }): number {
  return state.sundayUtcMidnight + 19.5 * 3600 * 1000;
}
export { simFactWorld, SIM_SEASON, SIMULATED } from './facts';
export type { SimFactWorldOptions } from './facts';
